<template>
  <RouterView />
</template>

<script>
import Session from '@/plugins/session'

export default {
  async beforeRouteEnter (to, from, next) {
    let redirect

    if (await Session.active &&
      !to.query.hasOwnProperty('impersonation-token') &&
      (!(await Session.instance).team.legacy.shipper ||
        (await Session.instance).team.legacy.biller)) {
      redirect = {
        name: 'application',
        replace: true
      }
    }

    next(redirect)
  }
}
</script>
